import Vue from "vue"
import App from "./App.vue"
import BootstrapVue from "bootstrap-vue"
import { BootstrapVueIcons } from "bootstrap-vue"
import "./custom.scss"
import i18n from "./i18n"
import router from "./router"
import { kee } from "./keecloak"
import "leaflet/dist/leaflet.css"
import "./mapfix"
import "./vee-validate"
import localizeFilter from "@/filters/localize"
import store from './store'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.filter('localize', localizeFilter)

Vue.config.productionTip = process.env.NODE_ENV != "production"

kee.init().then(() => {
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount("#app")
})